import React, { Fragment, ReactElement } from "react";
import { NavLink } from "react-router-dom";
import Menu from "material-ui-popup-state/HoverMenu";
import {
  usePopupState,
  bindHover,
  bindMenu
} from "material-ui-popup-state/hooks";

import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";

import IconChevronRight from "@material-ui/icons/ChevronRight";

const ParentPopupState = React.createContext(null);

const NavBarSubMenu = React.forwardRef<any, any>(
  ({ classes, title, popupId, disabled, children, ...props }, ref) => {
    const popupState = usePopupState({
      popupId,
      variant: "popover",
      parentPopupState: React.useContext(ParentPopupState)
    });

    return (
      <ParentPopupState.Provider value={popupState}>
        <MenuItem
          {...bindHover(popupState)}
          selected={popupState.isOpen}
          disabled={disabled}
          ref={ref}
        >
          <ListItemText>{title}</ListItemText>
          <IconChevronRight />
        </MenuItem>
        <Menu
          {...bindMenu(popupState)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          getContentAnchorEl={null}
          {...props}
        >
          {children}
        </Menu>
      </ParentPopupState.Provider>
    );
  }
);

const NavBarMenu = ({ icon, items }: { icon: ReactElement; items: any[] }) => {
  const popupState = usePopupState({ popupId: "demoMenu", variant: "popover" });

  return (
    <Fragment>
      <IconButton {...bindHover(popupState)}>{icon}</IconButton>
      <ParentPopupState.Provider value={popupState}>
        <Menu
          {...bindMenu(popupState)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          getContentAnchorEl={null}
        >
          {items.map(item =>
            item.items ? (
              <NavBarSubMenu
                key={item.name}
                popupId={item.name}
                title={item.name}
                disabled={item.disabled}
              >
                {item.items.map((item: any) => (
                  <MenuItem
                    key={item.name}
                    onClick={popupState.close}
                    disabled={item.disabled}
                  >
                    {item.link ? (
                      <NavLink to={item.link}>{item.name}</NavLink>
                    ) : (
                      item.name
                    )}
                  </MenuItem>
                ))}
              </NavBarSubMenu>
            ) : (
              <MenuItem
                key={item.name}
                onClick={popupState.close}
                disabled={item.disabled}
              >
                {item.link ? (
                  <NavLink to={item.link}>{item.name}</NavLink>
                ) : (
                  item.name
                )}
              </MenuItem>
            )
          )}
        </Menu>
      </ParentPopupState.Provider>
    </Fragment>
  );
};

export default NavBarMenu;
